<template>
  <div>
    <Loading :active.sync="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage"></Loading>
    
    <div class="popup" v-if="deletePopup.showPopup">
      <div class="flow--overlay" @click="deletePopup.showPopup = false">
          <div class="popup--box">
            <div class="flow--content">
              <div class="flow--title">Are you sure you want to delete '{{deletePopup.selectedContest.name}}'?</div>
              <hr />
              <p class="flow--p">Your contest <strong style="font-weight: 700;">including all submissions</strong> will be deleted permanently. This can not be undone!</p>
              <div class="page-new--button" style="background: color(srgb 1 0.324 0.324); display: inline-block;color: white; float: unset;" @click="deleteContestConfirm()">
                Yes, delete
              </div>
              <div class="page-new--button" style="background: black; color: white; float: unset;  margin-left: 1em; display: inline-block;" @click="deletePopup.showPopup = false">
                Cancel
              </div>
          </div>
          </div>
      </div>
    </div>
    
    
    <div class="flow" v-if="activateFlow">
      <div class="flow--overlay" @click="activateFlow = false">
        {{pageStep}}
      </div>
      <div class="flow--box">
        <div class="flow--top">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2034.52 1825.967">
            <g id="undraw_Add_files_re_v09g" transform="translate(-0.006 -0.006)">
              <path id="Path_89" data-name="Path 89" d="M1250.919,103.031l-66.2,17.072L369.119,330.43l-66.2,17.072A125.341,125.341,0,0,0,212.949,500L500.008,1613.148a125.341,125.341,0,0,0,152.5,89.97l.171-.044,947.658-244.382.171-.044a125.341,125.341,0,0,0,89.97-152.5L1403.417,193A125.341,125.341,0,0,0,1250.919,103.031Z" transform="translate(-208.978 -99.06)" fill="#f2f2f2" />
              <path id="Path_90" data-name="Path 90" d="M1237.733,115.744l-78.41,20.22L368.14,339.994l-78.408,20.22a89.258,89.258,0,0,0-64.07,108.6L512.72,1581.96a89.258,89.258,0,0,0,108.6,64.07l.171-.044L1569.146,1401.6l.172-.044a89.258,89.258,0,0,0,64.068-108.6L1346.328,179.814a89.258,89.258,0,0,0-108.6-64.07Z" transform="translate(-186.79 -76.872)" fill="#fff" />
              <path id="Path_91" data-name="Path 91" d="M901.357,277.83,421.96,401.457a20.849,20.849,0,1,1-10.412-40.377l479.4-123.627a20.849,20.849,0,1,1,10.413,40.377Z" transform="translate(90.379 121.509)" fill="#f2f2f2" />
              <path id="Path_92" data-name="Path 92" d="M991.39,295.766l-562.676,145.1A20.849,20.849,0,0,1,418.3,400.491l562.676-145.1a20.849,20.849,0,1,1,10.413,40.377Z" transform="translate(101.196 150.234)" fill="#f2f2f2" />
              <path id="Path_93" data-name="Path 93" d="M931.626,395.2,452.229,518.83a20.849,20.849,0,1,1-10.412-40.377l479.4-123.627A20.849,20.849,0,1,1,931.625,395.2Z" transform="translate(138.856 309.489)" fill="#f2f2f2" />
              <path id="Path_94" data-name="Path 94" d="M1021.658,413.139l-562.676,145.1a20.849,20.849,0,1,1-10.413-40.377l562.676-145.1a20.849,20.849,0,1,1,10.413,40.377Z" transform="translate(149.673 338.214)" fill="#f2f2f2" />
              <path id="Path_95" data-name="Path 95" d="M961.894,512.577,482.5,636.2a20.849,20.849,0,1,1-10.412-40.377L951.481,472.2a20.849,20.849,0,1,1,10.413,40.377Z" transform="translate(187.332 497.47)" fill="#f2f2f2" />
              <path id="Path_96" data-name="Path 96" d="M1051.927,530.513l-562.676,145.1a20.849,20.849,0,0,1-10.412-40.378l562.676-145.1a20.849,20.849,0,0,1,10.413,40.377Z" transform="translate(198.149 526.195)" fill="#f2f2f2" />
              <path id="Path_97" data-name="Path 97" d="M510.566,453.89l-169.654,43.75a10.008,10.008,0,0,1-12.177-7.184L289.791,339.441a10.008,10.008,0,0,1,7.184-12.177l169.654-43.75a10.008,10.008,0,0,1,12.177,7.184L517.75,441.713a10.008,10.008,0,0,1-7.184,12.177Z" transform="translate(-80.067 195.836)" fill="#e6e6e6" />
              <path id="Path_98" data-name="Path 98" d="M540.834,571.264,371.18,615.014A10.008,10.008,0,0,1,359,607.83L320.06,456.814a10.008,10.008,0,0,1,7.184-12.177L496.9,400.887a10.008,10.008,0,0,1,12.177,7.184l38.944,151.016a10.008,10.008,0,0,1-7.184,12.177Z" transform="translate(-31.59 383.817)" fill="#e6e6e6" />
              <path id="Path_99" data-name="Path 99" d="M571.1,688.637l-169.654,43.75a10.008,10.008,0,0,1-12.177-7.184L350.328,574.188a10.008,10.008,0,0,1,7.184-12.177L527.166,518.26a10.008,10.008,0,0,1,12.177,7.184L578.287,676.46a10.008,10.008,0,0,1-7.184,12.177Z" transform="translate(16.886 571.797)" fill="#e6e6e6" />
              <path id="Path_100" data-name="Path 100" d="M1543.407,209.052H564.393a125.341,125.341,0,0,0-125.2,125.2V1483.818a125.341,125.341,0,0,0,125.2,125.2h979.014a125.341,125.341,0,0,0,125.2-125.2V334.252a125.341,125.341,0,0,0-125.2-125.2Z" transform="translate(159.716 77.089)" fill="#e6e6e6" />
              <path id="Path_101" data-name="Path 101" d="M1521.221,222.906H542.205a89.258,89.258,0,0,0-89.158,89.158V1461.63a89.258,89.258,0,0,0,89.158,89.158h979.016a89.258,89.258,0,0,0,89.157-89.158V312.064A89.258,89.258,0,0,0,1521.221,222.906Z" transform="translate(181.904 99.277)" fill="#fff" />
              <circle id="Ellipse_8" data-name="Ellipse 8" cx="228.548" cy="228.548" r="228.548" transform="translate(1577.429 1368.877)" fill="#df9221" />
              <path id="Path_102" data-name="Path 102" d="M1098.12,768.921h-79.495V689.426a29.811,29.811,0,0,0-59.621,0v79.495H879.508a29.811,29.811,0,1,0,0,59.621H959v79.495a29.811,29.811,0,0,0,59.621,0V828.542h79.495a29.811,29.811,0,0,0,0-59.621Z" transform="translate(817.163 798.693)" fill="#fff" />
              <path id="Path_103" data-name="Path 103" d="M1124.615,491.386H629.534a20.849,20.849,0,1,1,0-41.7h495.081a20.849,20.849,0,0,1,0,41.7Z" transform="translate(431.167 462.481)" fill="#e6e6e6" />
              <path id="Path_104" data-name="Path 104" d="M1210.618,518.433H629.534a20.849,20.849,0,1,1,0-41.7h581.084a20.849,20.849,0,1,1,0,41.7Z" transform="translate(431.167 505.799)" fill="#e6e6e6" />
              <path id="Path_105" data-name="Path 105" d="M1124.615,612.6H629.534a20.849,20.849,0,1,1,0-41.7h495.081a20.849,20.849,0,0,1,0,41.7Z" transform="translate(431.167 656.611)" fill="#e6e6e6" />
              <path id="Path_106" data-name="Path 106" d="M1210.618,639.647H629.534a20.849,20.849,0,1,1,0-41.7h581.084a20.849,20.849,0,1,1,0,41.7Z" transform="translate(431.167 699.93)" fill="#e6e6e6" />
              <path id="Path_107" data-name="Path 107" d="M688.083,613.36h-175.2a10.008,10.008,0,0,1-10-10V447.406a10.008,10.008,0,0,1,10-10h175.2a10.008,10.008,0,0,1,10,10V603.362A10.008,10.008,0,0,1,688.083,613.36Z" transform="translate(261.717 442.816)" fill="#e6e6e6" />
              <path id="Path_108" data-name="Path 108" d="M688.083,734.573h-175.2a10.008,10.008,0,0,1-10-10V568.62a10.008,10.008,0,0,1,10-10h175.2a10.009,10.009,0,0,1,10,10V724.576A10.008,10.008,0,0,1,688.083,734.573Z" transform="translate(261.717 636.947)" fill="#e6e6e6" />
              <path id="Path_109" data-name="Path 109" d="M1044.748,356.451h-365a20.849,20.849,0,0,1,0-41.7h365a20.849,20.849,0,1,1,0,41.7Z" transform="translate(511.583 246.375)" fill="#ccc" />
              <path id="Path_110" data-name="Path 110" d="M1130.751,383.5H679.745a20.849,20.849,0,0,1,0-41.7h451.006a20.849,20.849,0,0,1,0,41.7Z" transform="translate(511.583 289.694)" fill="#ccc" />
              <path id="Path_111" data-name="Path 111" d="M849.169,564.589h-336.5a10.008,10.008,0,0,1-10-10V291.971a10.008,10.008,0,0,1,10-10h336.5a10.008,10.008,0,0,1,10,10v262.62a10.008,10.008,0,0,1-10,10Z" transform="translate(261.379 193.879)" fill="#df9221" />
            </g>
          </svg>

        </div>
        <div class="flow--content" v-if="pageStep == 0">
          <div class="flow--title">Create Your New Contest</div>
          <p class="flow--p">Your page name will identify your page inside the ContestCrate interface.</p>
          <br />
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="flow--label">What is the name of your page?</div>
                <input type="text" placeholder="Page name" name="Name" required v-model="pageNew.name" class="input--text email login--input-bottom" />
              </div>
            </div>
          </div>
          <hr />
          <div class="flow--buttons">
            <div class="flow--button flow--button_center" v-if="pageNew.name != ''" @click="pageStep++">
              <div class="flow--button-contents"> ›</div>
            </div>
          </div>

        </div>
        <div class="flow--content" v-if="pageStep == 1">
          <div class="flow--title">Page Information</div>
          <p class="flow--p">This information will be shown on your page.</p>
          <br />
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="flow--label">Title </div>
                <input type="text" placeholder="Page name" name="Name" required v-model="pageNew.title" class="input--text email login--input-bottom" />
              </div>

              <div class="col-12">
                <div class="flow--label">Description</div>
                <textarea type="text" v-model="pageNew.description" required placeholder="Description" name="title" class="input--text email login--input-bottom input--textarea"></textarea>
              </div>
            </div>
          </div>

          <hr />
          <div class="flow--buttons">
            <div class=" flow--button_left" @click="pageStep--">
              <div class="flow--button-contents"> ‹ Back</div>
            </div>
            <div class="flow--button flow--button_right" v-if="pageNew.title != '' && pageNew.description != ''" @click="pageStep++">
              <div class="flow--button-contents"> ›</div>
            </div>
          </div>

        </div>
        <div class="flow--content" v-if="pageStep == 2">
          <div class="flow--title">Claim Your Unique URL</div>
          <p class="flow--p">
            This will be your shareable url. Make sure you choose a descriptive name.
            Don't use whitespaces.
          </p>
          <br />
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="flow--field-inline">

                  <div class="flow--label-inline">remixinbox.com/</div>
                  <input type="text" placeholder="URL" name="URL" @change="checkAvailablity(pageNew.customUrl)" v-model="pageNew.customUrl" required v-bind:class="{ field_valid: available, field_invalid: !available }" class="input--text flow--inline-field email login--input-bottom" />
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="flow--buttons">
            <div class=" flow--button_left" @click="pageStep--">
              <div class="flow--button-contents"> ‹ Back</div>
            </div>
            <div class="flow--button flow--button_right" v-if="available" @click="pageStep++">
              <div class="flow--button-contents"> ›</div>
            </div>
          </div>
        </div>
        <div class="flow--content" v-if="pageStep == 3">
          <div class="flow--title" @click="createPage()">Track Details</div>
          <p class="flow--p">Provide your participants with some details about the original track.</p>
          <br />
          <div class="container">
            <div class="row">
              <div class="col-6">

                <div class="page-editor--label">Artist name</div>
                <input type="text" placeholder="Artist name" name="Name" v-model="pageNew.trackArtist" class="input--text  login--input-bottom" />

              </div>
              <div class="col-6">
                <div class="page-editor--label">Track name</div>
                <input type="text" placeholder="Track name" name="Name" v-model="pageNew.trackName" class="input--text  login--input-bottom" />
              </div>
              <div class="col-12">
                <div class="page-editor--label">Track URL</div>
                <input type="text" placeholder="URL of the original track" name="Name" v-model="pageNew.trackUrl" class="input--text  login--input-bottom" />
              </div>
              <div class="col-12">
                <div class="page-editor--label">Stems URL</div>
                <input type="text" placeholder="URL of the original track" name="Name" v-model="pageNew.trackStems" class="input--text  login--input-bottom" />
                <p>Make sure you use valid URL's.</p>
              </div>
            </div>
          </div>
          <div class="flow--buttons">
            <div class=" flow--button_left" @click="pageStep--">
              <div class="flow--button-contents"> ‹ Back</div>
            </div>
            <div class="flow--button flow--button_right" v-if="step3complete" @click="pageStep++">
              <div class="flow--button-contents"> ›</div>
            </div>
          </div>
        </div>
        <div class="flow--content" v-if="pageStep == 4">
          <div class="flow--title" @click="createPage()">Contest Details</div>
          <p class="flow--p">When does your contest start and close?</p>
          <br />
          <div class="page-editor--label">Start date</div>
          <Datepicker :monday-first="true" :disabledDates="disabledDatesOpen" v-model="pageNew.startDate"></Datepicker>
          <br>
          <div class="page-editor--label">Closing date</div>
          <Datepicker :monday-first="true" :disabledDates="disabledDatesClose" v-model="pageNew.endDate"></Datepicker>

          <div class="flow--buttons">
            <div class=" flow--button_left" @click="pageStep--">
              <div class="flow--button-contents"> ‹ Back</div>
            </div>
            <div class="flow--button flow--button_right" v-if="available" @click="pageStep++">
              <div class="flow--button-contents"> ›</div>
            </div>
          </div>
        </div>
        <div class="flow--content" v-if="pageStep == 5">
          <div class="flow--title" @click="createPage()">Branding</div>
          <p class="flow--p">Add a logo and background.</p>
          <br />
          <div class="page-editor--label">Logo</div>
          <div class="page-editor--logo" id="preview--logo" v-bind:style="{
                  'background-image':
                    'url(' + pageNew.logoUrl + ')',
                }"></div>
          <input type="file" @change="changeAssets($event, 'logo')" style="margin: 0; background-color: white; color: black; background-position: initial initial; background-repeat: initial initial;" accept="image/*" id="file-logo">
          <br>
          <div class="page-editor--label">Background</div>
          <div class="page-editor--background" id="preview--background" v-bind:style="{
                  'background-image':
                    'url(' + pageNew.backgroundUrl + ')',
                }"></div>
          <input type="file" @change="changeAssets($event, 'background')" style="margin: 0; background-color: white; color: black; background-position: initial initial; background-repeat: initial initial;" accept="image/*" id="file-background">

          <div class="flow--buttons">
            <div class=" flow--button_left" @click="pageStep--">
              <div class="flow--button-contents"> ‹ Back</div>
            </div>
            <div class="page-new--button" style="background: black; color: white; margin-bottom:4em;" v-on:click="createPage()">
              Create
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
    <div class="content" :key="this.$globals.contests">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="page-new--button" id="newContest" v-on:click="newPage()">+ New Contest</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-4" v-for="page in this.$globals.contests" :key="page.id">
            <div class="page-block">
              <div class="page-block--content">
                <div class="page-block--title">{{ page.name }}</div>
                <div class="page--link">
                  <div v-if="page.enabled" class="page--status-on"></div>
                  <div v-else class="page--status-off"></div>
                  <div class="page--url">
                    <a :href="'https://remixinbox.com/' + page.customUrl" target="_blank">
                      Visit contest page <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" height="11px" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg></a>

                  </div>
                </div>
              </div>
              <hr />
              <div class="page-block--actions">
                <router-link :to="{ name: 'contest-detail', params: { id: page.customUrl } }">
                  <div class="page-block--button">Edit Contest</div>
                </router-link>
                <div class="page-block--button-delete" @click="deleteContest(page)">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;" xml:space="preserve">
                    <g>
                      <g>
                        <g>
                          <path d="M64,341.333C64,364.907,83.093,384,106.667,384h170.667C300.907,384,320,364.907,320,341.333v-256H64V341.333z"/>
                          <polygon points="266.667,21.333 245.333,0 138.667,0 117.333,21.333 42.667,21.333 42.667,64 341.333,64 341.333,21.333 			"/>
                        </g>
                      </g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    </svg>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  //import ColorPicker from "../components/ColorPicker";
  import Datepicker from 'vuejs-datepicker';
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: "contests",
    components: {
      Datepicker,
      Loading
    },
    computed: {
      step3complete() {
        if (this.pageNew.trackArtist != '' && this.pageNew.trackName != '' && this.pageNew.trackStems != '' && this.pageNew.trackUrl != '') {
          var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
          if (pattern.test(this.pageNew.trackStems) && pattern.test(this.pageNew.trackUrl)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    data() {
      return {
        pages: this.$globals.contests,
        activateFlow: false,

        isLoading: false,
        fullPage: true,

        pageStep: 0,
        progress: {
          width: (this.pageStep * 20 + 20) + "%",
        },
        disabledDatesOpen: {
          to: new Date(Date.now() - 8640000)
        },
        disabledDatesClose: {
          to: new Date(Date.now() - 8640000)
        },
        pageNew: {
          title: "",
          name: "",
          description: "",
          customUrl: "",
          primaryColor: "#00000",
          secondaryColor: "#00000",
          textColor: "#FFFFF",
          enabled: 0,
          logoUrl: "https://api.contestcrate.com/img/defaultlogo.png",
          backgroundUrl: "https://api.contestcrate.com/img/defaultbackground.png",
          public: 1,
          trackArtist: "",
          trackName: "",
          trackStems: "",
          trackUrl: "",
        },
        available: false,
        
        deletePopup: {
          showPopup: false,
          selectedContest: null,
        }
      };
    },
    mounted() {

      this.isLoading = true;
      this.$globals.getContests();
      this.isLoading = false;

      /*if(localStorage.newAccount){
        const introJS = require("intro.js");
        introJS().setOptions({
          steps: [{
            intro: "This is the contest manager. Here you can manage all your contests and create new ones."
          }, {
            element: document.querySelector('#newContest'),
            intro: "Use this button to create a new contest."
          }]
        }).start().oncomplete(function() {
           window.location.href = '/Demos?multipage=true';
       }); 
      }*/
      self.isLoading = true;
      self.$globals.getContests();
      self.isLoading = false;

    },
    methods: {
      newPage: function() {
        this.activateFlow = true;
      },
      checkAvailablity: function() {
        var self = this;
        axios({
            method: "POST",
            crossdomain: true,
            headers: {
              "Content-Type": "Content-Type:application/json"
            },
            url: "/contest/check",
            data: {
              customUrl: self.pageNew.customUrl
            },
          })
        .then(function(response) {
          console.log(response.data);
          if (response.data.available) {
            self.available = response.data.available;
          } else {
            self.available = false;
          }
          console.log(self.available)
        })
        .catch(function(error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
      },
      changeAssets(event, type) {
        var file = event.target.files[0];
        var reader = new FileReader();
        if (type == "logo") {
          reader.onloadend = function() {
            document.getElementById("preview--logo").style.backgroundImage = 'url("' + reader.result + '")';
            document.getElementById("preview--form-logo").style.backgroundImage = 'url("' + reader.result + '")';
          }
          if (file) {
            reader.readAsDataURL(file);
          } else {
            console.log("no file");
          }

        } else {
          reader.onloadend = function() {
            document.getElementById("preview--background").style.backgroundImage = 'url("' + reader.result + '")';
            document.getElementById("preview--form-background").style.backgroundImage = 'url("' + reader.result + '")';
          }
          if (file) {
            reader.readAsDataURL(file);
          } else {
            console.log("no file");

          }
        }

      },
      timeConverter(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        return a;
      },
      createPage: function() {
        let self = this;
        this.isLoading = true;

        var formData = new FormData();
        var logo = document.querySelector('#file-logo');
        var background = document.querySelector('#file-background');


        if (logo.files[0]) {
          formData.append("logoImage", logo.files[0]);
        }

        if (background.files[0]) {
          formData.append("backgroundImage", background.files[0]);
        }
        console.log(self.pageNew);
        formData.append("enabled", 0);
        formData.append("title", self.pageNew.title);
        formData.append("primaryColor", self.pageNew.primaryColor);
        formData.append("secondaryColor", self.pageNew.secondaryColor);
        formData.append("textColor", self.pageNew.textColor);
        formData.append("trackName", self.pageNew.trackName);
        formData.append("trackArtist", self.pageNew.trackArtist);
        formData.append("trackStems", self.pageNew.trackStems);
        formData.append("startDate", new Date(self.pageNew.startDate).getTime() / 1000);
        formData.append("endDate", new Date(self.pageNew.endDate).getTime() / 1000);
        formData.append("description", self.pageNew.description);
        formData.append("customUrl", self.pageNew.customUrl);
        formData.append("name", self.pageNew.name);

        axios.post("/contest", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': "Bearer " + localStorage.token,
            }
          })
          .then(function(response) {
            console.log(response);
            self.isLoading = false;
            self.$globals.getContests();
            self.activateFlow = false;
          })
          .catch(function(error) {
            self.errors = error.response.data;
            self.isLoading = false;
          });

      },
      deleteContest: function(page) {
        this.deletePopup.showPopup = true;
        this.deletePopup.selectedContest = page;
      },
      deleteContestConfirm: function() {
        var self = this;
        self.isLoading = true;
        axios({
            method: "DELETE",
            crossdomain: true,
            headers: {
              "Content-Type": "Content-Type:application/json"
            },
            url: "/contest/delete/" + self.deletePopup.selectedContest.customUrl,
            data: {
            },
          })
        .then(function() {
         self.isLoading = false;
         self.$globals.getContests();
        })
        .catch(function(error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
      }
    }
  };
</script>